interface ColorListPattern {
  [key: string]: string;
}

const colorList: ColorListPattern = {
  white: "#FFFFFF",
  black: "#000000",
  textGray: "#C5C5C5",
  hoverGray: "#f2f2f2",
  backgroundGray: "#EFEFEF",
  mainOrange: "#FFB029",
  lightBrown: "#C19553",
  darkBrown: "#947E52",
  ground: "#4A3A19",
  blueprint: "#396ACC",
  gold: "#D4A900",
  blue: "#00B2CE",
  warningRed: "#FF0000",
  lightGreen: "#08cc0f",
  green: "#009105",
  yellow: "#FFCC00",
  backgroundGradient: "linear-gradient(to top right, #FFE229 0%, #FFB029 40%, #FF7229 100%);",
}

export default colorList;